import React, { useMemo } from "react";
import { useAuth } from "../../../../context/AuthContext";

/**
 * Left panel of the two-pane reports workspace: the full list of available
 * reports. Selecting one updates the right panel in place — no navigation.
 * Gated the same way the old category grid was, via the admin-level
 * category_<id> feature toggles under the "reports" module.
 */
const ReportsList = ({ categories, selectedCategoryId, onSelect, theme, isRTL }) => {
  const isDark = theme === "dark";
  const { isFeatureVisible } = useAuth();

  const visibleCategories = useMemo(
    () => categories.filter((c) => c.id !== "all" && isFeatureVisible?.("reports", `category_${c.id}`) !== false),
    [categories, isFeatureVisible]
  );

  return (
    <div
      style={{
        borderRadius: 18, padding: 10,
        border: `1px solid ${isDark ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.06)"}`,
        background: isDark ? "rgba(255,255,255,0.02)" : "#fff",
        boxShadow: isDark ? "0 8px 26px rgba(0,0,0,0.25)" : "0 8px 26px rgba(15,23,42,0.06)",
        display: "flex", flexDirection: "column", gap: 4,
        height: "fit-content",
      }}
    >
      {visibleCategories.map((category) => {
        const Icon = category.icon;
        const isSelected = category.id === selectedCategoryId;
        return (
          <button
            key={category.id}
            type="button"
            onClick={() => onSelect(category.id)}
            style={{
              display: "flex", alignItems: "center", gap: 10, padding: "10px 12px", borderRadius: 12,
              border: "none", cursor: "pointer", textAlign: isRTL ? "right" : "left",
              background: isSelected ? (isDark ? "rgba(59,130,246,0.15)" : "rgba(37,99,235,0.08)") : "transparent",
              color: isSelected ? (isDark ? "#93c5fd" : "#1d4ed8") : (isDark ? "#e2e8f0" : "#334155"),
            }}
            onMouseEnter={(e) => { if (!isSelected) e.currentTarget.style.background = isDark ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.03)"; }}
            onMouseLeave={(e) => { if (!isSelected) e.currentTarget.style.background = "transparent"; }}
          >
            <span
              style={{
                width: 30, height: 30, borderRadius: 9, flexShrink: 0,
                display: "flex", alignItems: "center", justifyContent: "center",
                background: isSelected ? `${category.color}30` : (isDark ? "rgba(255,255,255,0.06)" : "rgba(15,23,42,0.05)"),
                color: isSelected ? category.color : (isDark ? "rgba(255,255,255,0.5)" : "rgba(30,41,59,0.5)"),
              }}
            >
              <Icon size={15} />
            </span>
            <span style={{ fontSize: 12.5, fontWeight: 600 }}>{category.name}</span>
          </button>
        );
      })}
    </div>
  );
};

export default ReportsList;
